import "./index.scss";
import { GroupedDiscountRow } from "..";

export const GroupedDiscountList = ({
  brandDetails,
  productSummaries,
  onSuccessInAddingToCart
}) => (
  <table className="grouped-discount-list">
    <thead>
      <tr className="table-header">
        <th>Card Value</th>
        <th className="hide-on-mobile">Discount</th>
        <th>Your Price</th>
        <th>Stock</th>
        <th className="spacing-left">Amount</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {productSummaries.map((props) => (
        <GroupedDiscountRow
          key={`${props.price}-${props.value}-${props.discount}`}
          productSourceId={brandDetails.productSourceId}
          onSuccessInAddingToCart={onSuccessInAddingToCart}
          {...props}
        />
      ))}
    </tbody>
  </table>
);
